import { useReducer, useEffect } from 'react';

import useFetch from '~/hooks/useFetch';
import GraphQLReducer from '~/reducers/graphql';

const useGraphQLRequest = (query) => {
    const [state, dispatch] = useReducer(GraphQLReducer, {
        data: {},
        status: 'idle',
        error: null
    });
    const { data, loading, error } = useFetch(
        process.env.GATSBY_CMS_GRAPHQL_URL,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query
            })
        }
    );

    useEffect(() => {
        if (loading) {
            dispatch({ type: 'FETCHING' });
        } else if (data) {
            if (data.errors) {
                dispatch({ type: 'GRAPHQL_ERROR', error: data.errors });
            } else {
                dispatch({ type: 'GRAPHQL_SUCCESS', data: data.data });
            }
        } else if (error) {
            dispatch({ type: 'FETCH_ERROR', error: error });
        }
    }, [loading, data, error]);

    return state;
};

export default useGraphQLRequest;
